import { Injectable } from '@angular/core';
import {BehaviorSubject, interval, Subscription} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GlobalLoaderService {

  constructor() { }
  private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    private messageSubject = new BehaviorSubject<string>('');
    message$ = this.messageSubject.asObservable();

    private texts: string[] = ['Saving data', 'Please wait', 'Almost there', 'Fetching information'];
    private textIndex: number = 0;
    private intervalSubscription: Subscription = new Subscription();

    showLoader() {
        this.loadingSubject.next(true);
        this.startLoadingTextCycle();
    }

    hideLoader() {
        this.loadingSubject.next(false);
        this.intervalSubscription.unsubscribe();
    }

    private startLoadingTextCycle() {
        this.textIndex = 0;
        this.messageSubject.next(this.texts[this.textIndex]);

        // Start the interval for subsequent texts after a delay
        this.intervalSubscription = interval(2500).subscribe(() => {
            this.textIndex++;
            if (this.textIndex >= this.texts.length) {
                this.textIndex = 0;
            }
            setTimeout(() => {
                this.messageSubject.next(this.texts[this.textIndex]);
            }, 1250);
        });
    }
}
